import React from "react";
import ArtistPicker from "../../components/ArtistPicker/ArtistPicker";
import XIconRemoveButton from "../../components/buttons/XIconRemoveButton";

interface Props {
  artist: server.dto.ArtistSmall
  onArtistSelected: (artist: server.dto.ArtistSmall) => void
  noArtistError: boolean
}

const ArtistSelection = (props: Props) => {
  const artistPickerStyle: React.CSSProperties = {
    display: props.artist == null ? undefined : "none"
  };

  const selectableArtistStyle: React.CSSProperties = {
    display: props.artist == null ? "none" : undefined
  };

  return <>
    <div style={artistPickerStyle}>
      <ArtistPicker
        value={null}
        onChanged={props.onArtistSelected}
        filter="limitByUserAccess"
        error={props.noArtistError}
      />
    </div>
    <div style={selectableArtistStyle}>
      <div className="flex s1_text gap">
        <XIconRemoveButton onClick={() => { props.onArtistSelected(undefined); }} />
        <div>
          <span>{props.artist?.name}</span>
        </div>
      </div>
    </div>
  </>;
};

export default ArtistSelection;
